import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function Loading() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh', 
        bgcolor: 'background.default', 
        gap: 3, 
      }}
    >
      <CircularProgress size={48} thickness={4} color="primary" disableShrink />
      
      <Typography
        variant="button"
        color="text.secondary"
        sx={{
          letterSpacing: 2,
          animation: 'pulse 1.5s ease-in-out infinite',
          '@keyframes pulse': {
            '0%': { opacity: 0.5 },
            '50%': { opacity: 1 },
            '100%': { opacity: 0.5 },
          },
        }}
      >
        {t('Loading...')}
      </Typography>
    </Box>
  )
}
